<template>
  <div class="field-group">
    <label class="field-label-compact">
      Género<span class="required-asterisk">*</span>
    </label>
    <el-select
      v-prevent-select-keyboard
      :model-value="gender || undefined"
      class="field-select-compact premium-select"
      size="large"
      placeholder="Selecciona tu género"
      teleported
      popper-class="widget-select-dropdown premium-dropdown"
      :popper-options="selectPopperOptions"
      @update:model-value="emit('update:gender', $event)"
    >
      <el-option label="Hombre" value="M" />
      <el-option label="Mujer" value="F" />
    </el-select>
  </div>
</template>

<script setup lang="ts">
import { preventSelectKeyboard } from '@/directives/preventSelectKeyboard';
import { selectPopperOptions } from './selectPopperOptions';

const vPreventSelectKeyboard = preventSelectKeyboard;

defineProps<{ gender: 'M' | 'F' | '' }>();

const emit = defineEmits<{ 'update:gender': [value: unknown] }>();
</script>

<style scoped src="./fields.css"></style>
<style scoped src="./inputs.css"></style>
